import script from "./PropSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./PropSidebar.vue?vue&type=style&index=0&id=133cf0b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133cf0b8"]])

export default __exports__